'use strict';

var React = require('react');

var SvgMaximizeMinor = function SvgMaximizeMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3a1.5 1.5 0 0 0-1.5 1.5v2.5a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 0-2h-2.5zm-1.5 12.5a1.5 1.5 0 0 0 1.5 1.5h2.5a1 1 0 1 0 0-2h-2v-2a1 1 0 1 0-2 0v2.5zm14 0a1.5 1.5 0 0 1-1.5 1.5h-2.5a1 1 0 1 1 0-2h2v-2a1 1 0 1 1 2 0v2.5zm0-11a1.5 1.5 0 0 0-1.5-1.5h-2.5a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2.5z"
  }));
};

exports.SvgMaximizeMinor = SvgMaximizeMinor;
